import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Getting lucky with Bitcoin",
  "description": "",
  "published": "2013-11-19T00:00:00.000Z",
  "redirect_from": ["/blog/getting-lucky-with-bitcoin/swizec/6425"],
  "categories": "Bank account, Bitcoin, Bitstamp, Business, Financial Services, Slovenia, Travel + Events",
  "hero": "./img/images-4138.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "379px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c24f8da8918322add8dcd267ceab1894/811d1/images-4138.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.64125560538116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'239\\'%20viewBox=\\'0%200%20400%20239\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M149%2021l-2%209c0%207%202%2010%207%2010s7-3%207-10c0-8-2-11-7-11-3%200-4%201-5%202m23%200c-2%202-2%203-2%208%200%207%202%2011%208%2011%204%200%206-3%206-10%200-8-2-11-7-11l-5%202m16%200l-2%209c0%207%202%2010%207%2010s7-3%207-10c0-8-2-11-7-11-3%200-4%201-5%202m16%200l-2%209c0%207%202%2010%207%2010s7-3%207-10c0-6%200-7-2-9-3-3-8-3-10%200m16-1c-3%202-2%205%201%205l3-1c3-1%202%203-2%208-6%207-6%207%203%208%207%200%207%200%207-2%200-3%200-3-4-3h-3l3-4c4-4%205-6%202-10-1-2-7-3-10-1m16%200c-2%201-3%206-1%208v3c-6%206%204%2012%2011%207%202-1%203-5%200-7v-4c2-3%202-4%200-6s-7-3-10-1m15%201c-3%203%200%205%203%203%206-2%205%202%200%208-7%207-7%208%202%208%207%200%208-1%208-3s0-2-4-2h-3l3-4c3-3%204-8%201-10-2-3-8-2-10%200m15-1c-3%201%200%205%203%204s6%200%205%202l-4%201c-3%200-3%204%201%204%203%201%204%203%202%204h-5c-3-1-3-1-3%202%200%202%201%203%205%203s6%200%207-2c2-1%203-8%201-8v-3c3-5%200-8-6-8l-6%201m16%201v9c-2%202-1%208%201%209%203%202%209%201%2010-1%202-1%203-6%201-8v-4c2-4-1-7-6-7l-6%202m23-1v11l1%209h5c5%200%206%200%208-2s3-6%201-7v-5c0-3%200-5-2-6h-13m16%200c0%203%201%204%204%204%202%200%202%200%202%208s0%208%203%208c2%200%202%200%202-8s0-8%203-8c2%200%202%200%202-2%200-3%200-3-8-3l-8%201m20%201c-4%204-4%2012%200%2016%204%205%2013%204%2013-1l-4-1c-4%200-6-1-6-5%200-5%202-7%206-6%203%201%205-1%204-4-2-2-10-1-13%201M21%2025l-1%205v4h4c3%200%204-1%204-3%200-5%200-5%202-5l1%204%201%204%201-4%202-5c1-1%201-1-3-1l-4%201h-7m131%2075l-2%203c-4%201-4%205%200%208s4%204%200%204c-3-1-3-1-3%202%200%202%201%202%203%203%202%200%203%201%203%202h3l3-3c3-2%203-8%200-9-4-2-4-4-1-4%203-1%204-4%201-4l-3-1c-2-2-3-2-4-1m38%201c-4%202-3%205%202%204%205%200%205%201%200%208-7%207-7%208%202%208%207%200%208-1%208-2%200-2-1-3-4-3h-3l3-4c7-7%201-15-8-11m31%201c-2%201-3%205-1%207v3c-4%207%204%2012%2011%208%202-1%203-7%201-9v-3c3-6-5-10-11-6m42-1c-5%202-7%2013-3%2018%201%202%208%203%2010%200%205-4%201-13-5-12h-2l6-3%202-1c0-3-4-4-8-2m-97%203c-4%202-3%206%201%204%202-1%202-1%202%206s0%207%203%207h2v-20h-3c-1%200-4%201-5%203m40%200c-3%202-3%202-2%204h3c2-1%202%200%202%206%200%207%200%207%203%207h2v-20h-3c-1%200-4%201-5%203m39%203c-5%208-5%2010%200%2010%203%200%204%200%204%202l3%202c2%200%203-1%203-2l1-2%201-2-1-2-1-6c0-6%200-6-3-6-2%200-3%201-7%206m-195%204c0%205%200%205%202%205l4-2h2c1%202%206%203%207%201s-1-7-4-7c-2%200-3%202%200%202v1c-3%201-4%201-4-1l-3-2-2-1-1-2-1%206m-30%2082v21h157v-42H20v21m167%200l1%2021h193v-42H187v21m-80%201l1%205%201-1c0-3%205-4%207-2%201%203%205%204%208%202h1l3%201c4-1%205-4%202-6v-1l2-1c0-3-6-2-6%200h-2c-1-2-6-3-8%200h-2l-4-2c-3%200-3%200-3%205m149-4c0%207%204%2011%205%207l1-2%201%202c1%203%204%203%205-1l1-4v3l1%204c2%200%202-1%202-5%200-5%200-5-3-5l-3%202-1%202-1-2c-1-3-3-3-4%201v2l-1-2c-1-3-3-4-3-2m17%201l2%201%201%204%201%203%201-3%202-4c1-1%201%200%201%203s0%204%202%204l1-2%202-2%201%202%202%202%201-5c0-4-3-7-3-3%200%203-3%203-3%200-1-3-11-3-11%200m29%203c0%204%200%205%202%205l1-2h1c2%202%204%202%207%201h3l3%201c0-3-4-10-5-10s-2%201-4%207l-1%201v-3c2-3%200-5-4-5-3%200-3%200-3%205m-252%202c-3%201-3%202-3%205l1%203h24v-4c0-2%200-3-3-4-3-2-4-1-2%201%201%201%201%201-1%201l-2%202-4%201-5-1-2-2c-2%200-2%200-1-1%203-2%201-3-2-1m167%200c-2%201-2%202-2%205l1%203h24v-4c0-2%200-3-3-4-3-2-4-1-2%201%201%201%201%201-1%201l-2%202-4%201-5-1-2-2c-2%200-2%200-1-1%203-3%201-4-3-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c24f8da8918322add8dcd267ceab1894/ca0a1/images-4138.webp 223w", "/static/c24f8da8918322add8dcd267ceab1894/8a4f3/images-4138.webp 379w"],
                "sizes": "(max-width: 379px) 100vw, 379px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c24f8da8918322add8dcd267ceab1894/e92b6/images-4138.png 223w", "/static/c24f8da8918322add8dcd267ceab1894/811d1/images-4138.png 379w"],
                "sizes": "(max-width: 379px) 100vw, 379px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c24f8da8918322add8dcd267ceab1894/811d1/images-4138.png",
                "alt": "Tasty tasty bitcoins",
                "title": "Tasty tasty bitcoins",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Tasty tasty bitcoins`}</figcaption>{`
  `}</figure></p>
    <p>{`In April I was implementing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Bitcoin",
        "title": "Bitcoin"
      }}>{`Bitcoin`}</a>{` integration for a client and the more I read about how Bitcoin works, the more I liked it.`}</p>
    <p>{`So I decided to buy 200 euro worth of bitcoin on `}<a parentName="p" {...{
        "href": "http://www.bitstamp.net/",
        "title": "Bitstamp"
      }}>{`Bitstamp`}</a>{`. Mostly because I could upload money with a SEPA bank transfer. But also because they're from Slovenia and if anything goes wrong, I can knock on their door and ask some questions.`}</p>
    <p>{`I had about 2.54 btc to play with.`}</p>
    <p>{`Naturally I wanted to do arbitrages and look at graphs all day and try to make money from selling when Bitcoin is high and buying when it's low. Staking out the graphs, listening for the beeps a sale makes, twitchy fingers on the sell button ...`}</p>
    <p>{`... I lost 50 euro in two days. Then another 20 or 30 by the end of the week.`}</p>
    <p>{`Better idea! I'll write an algorithm to do this for me because I suck at it.`}</p>
    <p>{`Just before I started working on the algorithm I turned every dollar on the Bitstamp account into Bitcoin. Then promptly got busy with other stuff.`}</p>
    <h2 {...{
      "id": "getting-lucky"
    }}>{`Getting lucky`}</h2>
    <p>{`Every once in a while I would remember the poor project laying abandoned on my Github account. That I should really get back to it. That I could make a bunch of money if I made a high frequency or even a low frequency `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Algorithmic_trading",
        "title": "Algorithmic trading"
      }}>{`trading algorithm`}</a>{` for bitcoins.`}</p>
    <p>{`Even just a semiautomatic system that finds the best buy/sell moment after I tell it to do something would be a great help. Oh the endless possibilities and infinite laziness in actually doing something about them.`}</p>
    <p>{`But time passed. Bitcoin did its thing. And yesterday morning it hit $588 per coin.`}</p>
    <p>{`Wait what?`}</p>
    <p><em parentName="p">{`"Holy crap! I have to sell"`}</em>{`, I thought to myself. I didn't even think about the fact it would continue to grow before it crashes. I didn't think about anything.`}</p>
    <p>{`I just sold. Bam.`}</p>
    <p>{`Some 2.15 bitcoin gone.`}</p>
    <p>{`Some $1200 made.`}</p>
    <p>{`\\`}{`o/`}</p>
    <p>{`Pretty good return on investment if you ask me. Put $270 in, get $1200 out a few months later. 400% return, and I just wish I had put more money in. But the hell if I knew this was going to happen.`}</p>
    <h2 {...{
      "id": "money-isnt-money-until-its-your-money"
    }}>{`Money isn't money until it's your money`}</h2>
    <p>{`But money's not money until it hits your bank account. As great as Bitstamp is, a bank account it's not.`}</p>
    <p>{`Withdrawing the money was greeted with a lovely `}<em parentName="p">{`"Ohai thar, we don't believe you're a real human. Please verify your account by sending government issued ID and proof of residence."`}</em></p>
    <p>{`Didn't need that to `}<em parentName="p">{`take`}</em>{` my money did you Bitstamp? Now suddenly it's a big deal and I have to jump through hoops.`}</p>
    <p>{`But I understand.`}</p>
    <p>{`Bitstamp is a money instrument. They might have become more stringent in the last couple of months. As they should. I had to do all of this to get a UK credit card from `}<a parentName="p" {...{
        "href": "http://www.skrill.com/",
        "title": "Moneybookers"
      }}>{`Skrill`}</a>{` as well.`}</p>
    <p>{`Sent files through their form. No email confirmation that I sent the info, just account status changing from "UNVERIFIED" to "PENDING". No estimate how long it would take.`}</p>
    <p><em parentName="p">{`sigh`}</em></p>
    <p>{`Bitstamp, you are not being very serious right now.`}</p>
    <p>{`Today I go to check up on my application and bask in the glory of that boldened $1200 figure staring at me from the screen.`}</p>
    <p>{`Nope. Get a scary `}<em parentName="p">{`"We are fairly certain you are not a real person"`}</em>{` notice. Right from their cloud hosting too!`}</p>
    <p>{`Bitstamp going through a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Denial-of-service_attack",
        "title": "Denial-of-service attack"
      }}>{`DDoS attack`}</a>{` of some sort. Or just being down. Or they don't like me anymore. They came back online while I was writing this post, but man was that scary.`}</p>
    <p>{`Funny how attached you get to money that isn't even your yet.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0419db4e-9609-4f13-a0a4-4786ce876c0a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      